import { Link } from "react-router-dom";

/**
 * Marquee-label CTA — the visible label translates up on hover and a
 * duplicate appears from below. Use as a Link or anchor; pass `to` for
 * internal links or `href` for external.
 */
export default function MarqueeLink({
  children,
  to,
  href,
  variant = "primary",
  className = "",
  ...rest
}) {
  const base =
    "marquee-link relative inline-flex items-center justify-center overflow-hidden font-heading uppercase tracking-[0.22em] text-[11px] font-semibold transition-colors duration-300 group";
  const padding = "px-6 py-3";

  const variants = {
    primary: "bg-[#EB1D25] text-white hover:bg-[#111111]",
    dark: "bg-[#111111] text-white hover:bg-[#EB1D25]",
    ghost:
      "bg-transparent border border-white text-white hover:bg-white hover:text-[#111111]",
    "ghost-dark":
      "bg-transparent border border-[#111111] text-[#111111] hover:bg-[#111111] hover:text-white",
  };

  const classes = `${base} ${padding} ${variants[variant] || variants.primary} ${className}`;

  const inner = (
    <span className="marquee-track flex flex-col h-[1.1em] overflow-hidden">
      <span className="marquee-line block">{children}</span>
      <span className="marquee-line block" aria-hidden="true">
        {children}
      </span>
    </span>
  );

  if (to) {
    return (
      <Link to={to} className={classes} {...rest}>
        {inner}
      </Link>
    );
  }
  return (
    <a href={href} className={classes} {...rest}>
      {inner}
    </a>
  );
}
